import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { Vehicle } from 'types/vehicle';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const BlockTitle = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #000;
  margin-bottom: 30px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #e0e0e0;
`;

const Label = styled.span<{ bold?: boolean }>`
  font-size: 14px;
  font-weight: ${props => (props.bold ? 700 : 500)};
  color: #000;
`;

const Value = styled.span<{ bold?: boolean }>`
  font-size: 14px;
  font-weight: ${props => (props.bold ? 700 : 500)};
  color: #000;
`;

const formatAmount = (amount: number) =>
  `$${amount.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;

const DateText = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: #666666;
  margin-left: 6px;
`;

const formatDate = (dateStr?: string | null) => (dateStr ? moment.utc(dateStr).format('MMM DD, YYYY') : null);

interface TransferRecord {
  check?: string | null;
  date_seller_was_paid?: string | null;
  date_cleared?: string | null;
  sell_fee?: string | null;
  additional_fees?: { fee_amount: number }[] | null;
}

interface PaymentHistoryBlockProps {
  vehicle: Vehicle & { transferRecord?: TransferRecord };
}

const PaymentHistoryBlock = ({ vehicle }: PaymentHistoryBlockProps) => {
  const tr = vehicle.transferRecord;

  const vehiclePrice = vehicle.vehicle_price ?? 0;
  const sellFee = Number(tr?.sell_fee) || 0;
  const additionalFeesTotal = (tr?.additional_fees ?? vehicle.additional_fees ?? []).reduce(
    (sum: number, f: any) => sum + Number(f.fee_amount),
    0
  );
  const sellAmount = vehiclePrice - sellFee - additionalFeesTotal;

  return (
    <Wrapper>
      <BlockTitle>Payment History</BlockTitle>

      <Row>
        <Label bold>Check # / Payment Method</Label>
        <Value>{tr?.check || '—'}</Value>
      </Row>

      <Row>
        <span>
          <Label>Date Sent</Label>
          {formatDate(tr?.date_seller_was_paid) && <DateText>{formatDate(tr?.date_seller_was_paid)}</DateText>}
        </span>
        {tr?.date_seller_was_paid && <Value>{formatAmount(sellAmount)}</Value>}
      </Row>

      <Row>
        <span>
          <Label>Date Cleared</Label>
          {formatDate(tr?.date_cleared) && <DateText>{formatDate(tr?.date_cleared)}</DateText>}
        </span>
      </Row>
    </Wrapper>
  );
};

export default PaymentHistoryBlock;
